import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CacheManager, fetchData, fetchFileFromZip, fetchToken } from "./counterAPI.js";
import { getUrlObj, removeSpecialCharacters, userLogged } from "../../utils/index.js";
import updateEnhancedTOC from "./updateEnhancedTOC.js";
import { updateOpenSectionStandAlone } from "./updateOpenSectionStandAlone.js";

import { apiService } from "../../api/apiAdapter.js";
// import JSZip from 'jszip';
// import { cleanDITA } from './dita-clean';
import { UpdateURL } from "./updateURL.js";

import $ from "jquery";
import { rxhtmltag4jQuery } from "./rxhtmltag.js";
import {
  addictionMedicine,
  antibiotic,
  boneandmetabolism,
  cardiovascular,
  dermatology,
  developmentaldisability,
  diabetes,
  fatigue,
  gastrointestinal,
  liverdisorders,
  neurology,
  oralanddental,
  other,
  painandanalgesia,
  palliativecare,
  psychotropic,
  quicklinks,
  respiratory,
  rheumatology,
  sexualandreproductivehealth,
  toxicologyandtoxinology,
  ulcerandwoundmanagement,
  wildernessmedicine,
  kidney,
} from "../../utils/guidelines.js";
import { isSalesforceEnabled } from "../../utils/featureFlagSalesforceUtils.js";

rxhtmltag4jQuery();

const TG_IDS = ["151", "168"];

export const QueryString = () => {
  let queryString = {};
  let querySearch = [];
  try {
    if (window.location.hash !== "") {
      // manage searchFixed topics wmg1-co etc...
      // console.log(window.location.hash);
      window.location.hash = window.location.hash.replace(/\#\w*-\w*-c_/g, "c_");
      // console.log(window.location.hash);
    }

    querySearch = window.parent.location.search.replace("?", "").split("&");
    $(querySearch).each((index, element) => {
      queryString[element.split("=")[0]] = element.split("=")[1];
    });
    // console.log(28,"Q>>>",JSON.stringify(queryString));
  } catch (error) {
    // console.log("no querystring",error);
  }
  return queryString;
};
// Check sessionStorage first for staff testing, fallback to env default
const ccmsversion =
  sessionStorage.getItem("ccms_selected_version") || import.meta.env.REACT_APP_CCMS_VERSION;

let expired = import.meta.env.REACT_APP_B2C_DISABLE_AUTH === "true" ? false : true;
try {
  let rawExpiry = localStorage.getItem("tg_expirydate");
  let decodedExpiry = atob(rawExpiry);

  if (decodedExpiry.startsWith('"') && decodedExpiry.endsWith('"')) {
    decodedExpiry = decodedExpiry.slice(1, -1);
  }
  let subscriptionExpired = new Date(decodedExpiry);
  const today = new Date();
  subscriptionExpired.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  if (subscriptionExpired && subscriptionExpired > today) {
    expired = false;
  }
} catch (error) {
  console.log("No valid token found." + error);
}

const tgt = localStorage.getItem("tgt");
if (tgt) {
  try {
    const decodedToken = JSON.parse(atob(tgt));
    if (decodedToken.exp) {
      // Handle both seconds and milliseconds timestamp formats
      const expTime = decodedToken.exp > 1000000000000 ? decodedToken.exp : decodedToken.exp * 1000;
      if (expTime > Date.now()) {
        expired = false;
      } else {
        localStorage.removeItem("tgt");
      }
    } else {
      // Token without expiration is valid
      expired = false;
    }
  } catch (e) {
    localStorage.removeItem("tgt");
  }
}

const persistedProgress = JSON.parse(sessionStorage.getItem("downloadZipProgress") || "{}");
const persistedIDBProgress = JSON.parse(sessionStorage.getItem("downloadIDBProgress") || "{}");

const initialState = {
  value: [], // fielPath
  showAccessKey: false,
  openSection: [],
  status: "idle",
  auth: 0,
  activeTopicHRefSearchPath: [],
  id: { u: null, i: null },
  institutionLoading: true,
  map: "",
  zip: null,
  ditaPath: "",
  XRefPath: "",
  uxPlatform: "desktop",
  queryString: QueryString(),
  defaultPath: "",
  changeGuideline: 0,
  fetchqueue: [],
  downloadProgress: 0,
  downloadZip: {
    // Temporary storage for individual zip parts during merge process
    // Cleared to null after merging into state.zip
    content: null,
    images: null,
    PDFs: null,
  },
  downloadZipProgress: {
    contentsReceived: persistedProgress.contentsReceived || 0,
    imagesReceived: persistedProgress.imagesReceived || 0,
    pdfsReceived: persistedProgress.pdfsReceived || 0,
  },
  downloadIDBProgress: {
    contentsReceived: persistedIDBProgress.contentsReceived || 0,
    imagesReceived: persistedIDBProgress.imagesReceived || 0,
    pdfsReceived: persistedIDBProgress.pdfsReceived || 0,
  },
  C5State: {
    platform: "tg.org.au",
    databaseID: "Antibiotic",
    siteID: "singlemulti",
    titleID: "bartenella-infections",
    itemID: "references",
    itemVersion: "1",
    publisherId: "tgl:TGL",
    proprietaryId: "tgl:Antibiotic",
    itemPubDate: "references",
    accessMethod: "Regular",
    eventType: "Request" /*Investigation,Searches_Regular */,
    sectionType: "Section",
    dataType: "Database",
    itemDataType: "Other",
    searchTerm: "",
    id: "",
  },
  ip: "0.0.0.0",
  medium: "",
  referenceFiles: {
    pbs_links: "preprocess/drug_key_links_trim.dita",
    source_experts: "Contributors/source_experts.dita",
    drug_keydef: "preprocess/drug_keydef_trim.ditamap",
    refContent: { file: "", active: 0 },
  },
  cache: {
    chapter: {
      title: "",
      children: 0,
      content: "<div>Processing...</div>",
      level: 6,
    },
  }, //filepath:{title:"title",content:"Dita"} //activeTopic:{title:"",content:""}
  version: {
    selected: ccmsversion,
    items: [
      { label: "Master", value: "main" },
      { label: "s6", value: "s6" },
      { label: "s7", value: "s7" },
      { label: "s8", value: "s8" },
      { label: "s9", value: "s9" },
      { label: "s10", value: "s10" },
      { label: "s11", value: "s11" },
      { label: "s12", value: "s12" },
      { label: "s13", value: "s13" },
      { label: "s14", value: "s14" },
    ],
  },
  iDB: new CacheManager({
    name: `${ccmsversion}_${import.meta.env.REACT_APP_CONTENT_VERSION}`,
  }),
  mpstopicfile: {
    Addiction_Medicine: {
      text: "Addiction",
      topicfile: "alcohol-drug-problems",
      mpsguidelineid: 34,
      bannerclass: "book-addiction",
      topiccode: "amg1-c",
      mobheader: "rgb(18, 72, 81)",
      squareIconClass: addictionMedicine.iconClassSuffix,
    },
    Antibiotic: {
      text: "Antibiotic",
      topicfile: "bartonella-infections",
      mpsguidelineid: 3,
      bannerclass: "book-antibiotic",
      topiccode: "abg16-c",
      mobheader: "rgb(247, 174, 173)",
      squareIconClass: antibiotic.iconClassSuffix,
    },
    Bone_and_Metabolism: {
      text: "Bone and Metabolism",
      topicfile: "thyroid-disorders-overview",
      mpsguidelineid: 28,
      bannerclass: "book-bone",
      topiccode: "bmg2-c",
      mobheader: "rgb(188, 191, 0)",
      squareIconClass: boneandmetabolism.iconClassSuffix,
    },
    Cardiovascular: {
      text: "Cardiovascular",
      topicfile: "cardiovascular-disease-risk-stratification",
      mpsguidelineid: 4,
      bannerclass: "book-cardiovascular",
      topiccode: "cvg7-c",
      mobheader: "rgb(155, 125, 186)",
      squareIconClass: cardiovascular.iconClassSuffix,
    },
    Dermatology: {
      text: "Dermatology",
      topicfile: "acne",
      mpsguidelineid: 5,
      bannerclass: "book-dermatology",
      topiccode: "dmg-c",
      mobheader: "rgb(149, 135, 113)",
      squareIconClass: dermatology.iconClassSuffix,
    },
    Developmental_Disability: {
      text: "Developmental Disability",
      topicfile: "cerebral-palsy",
      mpsguidelineid: 33,
      bannerclass: "book-developmental",
      topiccode: "ddg4-c",
      mobheader: "rgb(63, 196, 183)",
      squareIconClass: developmentaldisability.iconClassSuffix,
    },
    Diabetes: {
      text: "Diabetes",
      topicfile: "other-types-of-diabetes",
      mpsguidelineid: 26,
      bannerclass: "book-diabetes",
      topiccode: "dbg1-c",
      mobheader: "rgb(255, 244, 82)",
      squareIconClass: diabetes.iconClassSuffix,
    },
    Fatigue: {
      text: "Fatigue",
      topicfile: "fatigue-introduction",
      mpsguidelineid: 17,
      bannerclass: "book-fatigue",
      topiccode: "ftg-c",
      mobheader: "rgb(66, 65, 67)",
      squareIconClass: fatigue.iconClassSuffix,
    },
    Gastrointestinal: {
      text: "Gastrointestinal",
      topicfile: "disorders-oesophagus",
      mpsguidelineid: 7,
      bannerclass: "book-gastrointestinal",
      topiccode: "gig-c",
      mobheader: "rgb(0, 84, 159)",
      squareIconClass: gastrointestinal.iconClassSuffix,
    },
    Liver_Disorders: {
      text: "Liver Disorders",
      topicfile: "abnormal-liver-biochemistry",
      mpsguidelineid: 32,
      bannerclass: "book-liver",
      topiccode: "ldg1-c",
      mobheader: "rgb(70, 10, 104)",
      squareIconClass: liverdisorders.iconClassSuffix,
    },
    Neurology: {
      text: "Neurology",
      topicfile: "acute-management-of-seizures-and-status-epilepticus",
      mpsguidelineid: 8,
      bannerclass: "book-neurology",
      topiccode: "nrg5-c",
      mobheader: "rgb(236, 9, 40)",
      squareIconClass: neurology.iconClassSuffix,
    },
    Oral_and_Dental: {
      text: "Oral and Dental",
      topicfile: "dental-caries",
      mpsguidelineid: 9,
      bannerclass: "book-oral",
      topiccode: "dtg3-c",
      mobheader: "rgb(139, 131, 215)",
      squareIconClass: oralanddental.iconClassSuffix,
    },
    Other: {
      text: "Other",
      topicfile: "anaphylaxis",
      mpsguidelineid: 24,
      bannerclass: "book-other",
      topiccode: "oth-c",
      mobheader: "rgb(221, 222, 223)",
      squareIconClass: other.iconClassSuffix,
    },
    Pain_and_Analgesia: {
      text: "Pain and Analgesia",
      topicfile: "understanding-pain",
      mpsguidelineid: 2,
      bannerclass: "book-pain",
      topiccode: "agg7-c",
      mobheader: "rgb(0, 164, 229)",
      squareIconClass: painandanalgesia.iconClassSuffix,
    },
    Palliative_Care: {
      text: "Palliative Care",
      topicfile: "palliative-care-overview",
      mpsguidelineid: 10,
      bannerclass: "book-palliative",
      topiccode: "pcg4-c",
      mobheader: "rgb(186, 224, 202)",
      squareIconClass: palliativecare.iconClassSuffix,
    },
    Psychotropic: {
      text: "Psychotropic",
      topicfile: "delirium",
      mpsguidelineid: 11,
      bannerclass: "book-psychotropic",
      topiccode: "ptg8-c",
      mobheader: "rgb(0, 162, 97)",
      squareIconClass: psychotropic.iconClassSuffix,
    },
    Respiratory: {
      text: "Respiratory",
      topicfile: "asthma-introduction-and-diagnosis",
      mpsguidelineid: 19,
      bannerclass: "book-respiratory",
      topiccode: "rsg6-c",
      mobheader: "rgb(253, 191, 87)",
      squareIconClass: respiratory.iconClassSuffix,
    },
    Rheumatology: {
      text: "Rheumatology",
      topicfile: "gout",
      mpsguidelineid: 12,
      bannerclass: "book-rheumatology",
      topiccode: "rhg3-c",
      mobheader: "rgb(242, 105, 34)",
      squareIconClass: rheumatology.iconClassSuffix,
    },
    Sexual_and_Reproductive_Health: {
      text: "Sexual and Reproductive Health",
      topicfile: "sterilisation",
      mpsguidelineid: 27,
      bannerclass: "book-sexual",
      topiccode: "srg2-c",
      mobheader: "rgb(147, 55, 87)",
      squareIconClass: sexualandreproductivehealth.iconClassSuffix,
    },
    Toxicology_and_Toxinology: {
      text: "Toxicology and Toxinology",
      topicfile: "what-is-covered-in-toxicology-toxinology",
      mpsguidelineid: 30,
      bannerclass: "book-toxicology",
      topiccode: "ttg1-c",
      mobheader: "rgb(65, 83, 99)",
      squareIconClass: toxicologyandtoxinology.iconClassSuffix,
    },
    Ulcer_and_Wound_Management: {
      text: "Ulcer and Wound Management",
      topicfile: "fundamentals-of-ulcer-and-wound-management",
      mpsguidelineid: 14,
      bannerclass: "book-ulcer",
      topiccode: "lwg2-c",
      mobheader: "rgb(137, 212, 223)",
      squareIconClass: ulcerandwoundmanagement.iconClassSuffix,
    },
    Wilderness_Medicine: {
      text: "Wilderness Medicine",
      topicfile: "altitude-illness",
      mpsguidelineid: 31,
      bannerclass: "book-wilderness",
      topiccode: "wmg1-c",
      mobheader: "rgb(188, 189, 192)",
      squareIconClass: wildernessmedicine.iconClassSuffix,
    },
    Kidney_and_Urinary: {
      text: "Kidney and Urinary",
      topicfile: "kidney-overview",
      mpsguidelineid: 35,
      bannerclass: "book-kidney",
      topiccode: "kng1-c",
      mobheader: "rgb(247, 174, 173)",
      squareIconClass: kidney.iconClassSuffix,
    },
    quicklinks: {
      text: "Drug use in pregnancy and breastfeeding",
      topicfile: "altitude-illness",
      mpsguidelineid: 31,
      bannerclass: "book-wilderness",
      topiccode: "wmg1-c",
      mobheader: "rgb(188, 189, 192)",
      squareIconClass: quicklinks.iconClassSuffix,
    },
  },
  displayBanner: false,
  headTitle: "",
  tocId: "",
  hashRedirect: false,
  versionByImport: false,
  subscriptionStatus: {
    canPurchase: true,
    hasAppliedCoupon: false,
    status: "loading", // "idle" | "loading" | "succeeded" | "failed"
    error: null,
  },
  expired: expired,
  triggerCache: false,
  isAppMode: false, // for mobile app and mobile browser
  isModernView: false,
  isMobileAppMode: false, //for mobile app only from isOnSmallScreen() && isPWAInstalled();
};

const updateTOCJQuery = (state, action) => {
  state.referenceFiles.refContent.active = 0; // always deactivate modal if toc is updated.
  let stateMap = $("<span>").html(state.map);
  let hrefSelectedTopic = '[href="' + action.payload.selectedTopic + '"]:eq(0)';

  state.XRefPath = action.payload.tag === "H2" ? "" : action.payload.XRefPath; // make xrefPath blank to prevent scroll on H2 click
  // console.log(hrefSelectedTopic);

  let contentMap = $(stateMap).find(hrefSelectedTopic);
  let contentMapParent = $(stateMap).find(hrefSelectedTopic).parent();
  if ($(contentMap).attr("children") === 0) {
    contentMap = $(stateMap).find(hrefSelectedTopic).closest('[children!="0"]');
    contentMapParent = $(stateMap).find(hrefSelectedTopic).closest('[children!="0"]').parent();
  }
  // console.log("children",$(contentMap).attr("children"));
  //if(parseInt($(contentMap).attr("children"))===0)
  let contentTag = $(contentMapParent).prop("tagName");
  // console.log(contentTag);
  _updateOpenSection(state, action);

  if (!action.payload?.selectedTopic) {
    console.warn("updateTOC called with no selectedTopic");
    return;
  }
  if ($(stateMap).find(hrefSelectedTopic).hasClass("active")) {
    //simply toggle view
    // if(0){ //simply toggle view
    console.log("=====updateTOC", "simple toggle", hrefSelectedTopic);
    // console.log("simpletoggle>",hrefSelectedTopic,action.payload.dartSelectors);
    // updateOpenSection(state,{payload:{dartSelectors: action.payload.dartSelectors,filePath:hrefSelectedTopic}});
    // $(stateMap).find(hrefSelectedTopic).addClass("active");

    $(stateMap).find(hrefSelectedTopic).toggleClass("active");
    $(stateMap).find(hrefSelectedTopic).find("> map > topicref").toggleClass("active");
    // console.log(hrefSelectedTopic);
    // console.log($(stateMap).find(hrefSelectedTopic).prop("tagName"));
    if ($(stateMap).find(hrefSelectedTopic).prop("tagName") === "CHAPTER")
      $(stateMap)
        .find(hrefSelectedTopic)
        .closest("bookmap")
        .find("ditatitle")
        .toggleClass("active");
    // $(stateMap).find(hrefSelectedTopic).parents("bookmap:eq(0)").find("ditatitle:eq(0)").toggleClass("active");
    // $(stateMap).find(hrefSelectedTopic).parents("topicref:eq(0), chapter:eq(0)").toggleClass("active");
  } else if (
    parseInt(
      $(stateMap)
        .find(hrefSelectedTopic + ":eq(0)")
        .attr("children"),
    ) === 0 &&
    hrefSelectedTopic.indexOf(".dita#") === -1
  ) {
    //No children and not tnf, get file
    console.log("=====updateTOC", "No children, get file", hrefSelectedTopic);
    setTimeout(() => {
      $(".slider-arrow.hide").trigger("click");
    }, 1000);
    // console.log(JSON.stringify(state.value));
    // console.log(">>",state.value[0]);
    if (state.value.length === 0 || state.value[0].indexOf("tandf") !== 0) {
      // console.log("=======NoChildren...YES dispatch");
      NewTopicStyles(stateMap, hrefSelectedTopic);
      // console.log("DispatchCacheContent called from no children, get file");
      processCacheContent(contentTag, stateMap, state, action);
    } else {
      console.log("=======NoChildren...NO dispatch", hrefSelectedTopic);
      $(stateMap).find('topicref[children="0"].active').removeClass("active");
      $(stateMap).find(hrefSelectedTopic).addClass("active");
      $(stateMap).find(hrefSelectedTopic).parents("topicref, chapter").addClass("active");
    }

    // $(currentTopicRef).addClass("active");
  } else {
    // New Topic, get files
    console.log("=====updateTOC", "// New Topic, get files", action.payload.selectedTopic);
    // state.openSection=[]; // clear openSection since this is a new topic.
    NewTopicStyles(stateMap, hrefSelectedTopic);

    // console.log(contentTag);
    processCacheContent(contentTag, stateMap, state, action);
  }
  //console.log($(stateMap).html());
  const htmlMap = $(stateMap).html();
  if (htmlMap !== state.map) {
    state.map = htmlMap;
  }
};

//Important - change MPS guidelineID for live...
/*
  TTG: Live=29,Beta=30
  WMG: Live=30,Beta=31
  LDG: Live=31,Beta=32
  DDG: Live=32,Beta=33
  AMG: Live=33,Beta=34
*/

export const OpenTOCbyURL = (action, state) => {
  let targetTopic = undefined;
  let isModernView = state.isModernView;

  const hrefBeforeTimeout = location.href;
  let mapState = $("<body />").html(state.map);

  let queryString = "";
  try {
    queryString = action.payload?.queryString || initialState.queryString || {};
  } catch (error) {
    console.log(error);
  }

  let checklocalStorage;
  const uxPlatform = state.uxPlatform;

  setTimeout(() => {
    const hasPageChangedSinceTimeoutWasCreated = location.href !== hrefBeforeTimeout;
    if (hasPageChangedSinceTimeoutWasCreated) {
      // this timeout is being triggered via redux reducers therefore is will not self clean up.
      // in React this should be an Effect but we cannot use Effects in Redux reducers..
      // track the URL change manually incase it changes and abort if there is a URL change
      return;
    }

    // console.log(action.payload.dartSelectors);
    let urlObj = getUrlObj();
    targetTopic = (urlObj.pathname + urlObj.search + urlObj.hash).replace("#startdart", "");
    let urlExactMatch = false;
    let foundHash = false;

    if (targetTopic.indexOf("/access/") > -1) {
      targetTopic = '[tocpath="' + targetTopic + '"]';
    } else if (uxPlatform === "mobile") {
      targetTopic = queryString.topicFileName.replace(".html", "");
      targetTopic = 'topicref [mpspath*="topicfile=' + targetTopic + '"]:not([href*=".ditamap"])';

      let testTargetTopic = $(mapState).find(targetTopic).length;
      if (testTargetTopic === 0) {
        targetTopic = targetTopic.replace("topicref [mpspath*", "topicref[mpspath*");
        // console.log(128,"counterslide.js-mobile-mapState",$(mapState).html());
        // console.log(129,"counterslide.js-mobile-targetTopic",targetTopic);
      }

      targetTopic = $(mapState)
        .find(targetTopic)
        .not('topicref[mpspath*="guidelinename=auto"]')
        .first()
        .attr("href");
      // console.log(130, "counterSlice.js", JSON.stringify(queryString));

      try {
        if (queryString.topicSectionId.length > 0) {
          checklocalStorage = queryString.topicSectionId;
          // console.log(146,"counterSlice-checklocalStoragelength",checklocalStorage.length);
          // console.log(152,"counterSlice-sectionid",checklocalStorage);
        }
      } catch (error) {}

      try {
        if (queryString.topicDivId.length > 0) {
          checklocalStorage = queryString.topicDivId.replace("%7C", "|");
          // console.log(35, "counterSlice-checkocalStorage", checklocalStorage);
        }
      } catch (error) {}
    } else if (uxPlatform === "webpage") {
      let targetTopic = queryString.topicFileName.replace(".html", "");
      targetTopic = `topicref [mpspath*="topicfile=${targetTopic}"]:not([href*=".ditamap"])`;

      let testTargetTopic = $(mapState).find(targetTopic).length;
      if (testTargetTopic === 0) {
        targetTopic = targetTopic.replace("topicref [mpspath*", "topicref[mpspath*");
      }

      targetTopic = $(mapState)
        .find(targetTopic)
        .not('topicref[mpspath*="guidelinename=auto"]')
        .first()
        .attr("href");
    } else {
      // mps urls
      // if(targetTopic.indexOf("/viewTopic?topicfile")>-1){}
      // targetTopic=window.location.search.replace("?","");
      // console.log(targetTopic);
      targetTopic = '[mpspath*="' + targetTopic + '"]:not([href*=".ditamap"]):eq(0)';

      if (!isModernView) {
        const xrefHref = action.payload?.dartSelectors?.XRefPath;
        // console.log("normalizedHref:", normalizedHref);
        //try to find an exact match for the full href in the TOC.
        if (xrefHref) {
          const normalizedHref = xrefHref.replace(/^(\.\.\/)+/, "");
          if ($(mapState).find(`[href="${normalizedHref}"]`).length === 1) {
            targetTopic = `[href="${normalizedHref}"]`;
            foundHash = true;
          } else {
            //fall back to matching only by the child ID
            const afterHash = normalizedHref.split("#")[1] || "";
            const childId = afterHash.split("/")[1];
            if (childId) {
              const $cand = $(mapState).find(`[href$="/${childId}"]`).first();
              if ($cand.length) {
                targetTopic = `[href="${$cand.attr("href")}"]`;
                foundHash = true;
              }
            }
          }
        }
      }

      if ($(mapState).find(targetTopic.replace("mpspath*=", "mpspath=")).length === 1) {
        targetTopic = targetTopic.replace("mpspath*=", "mpspath=");
        urlExactMatch = true;
      } else if (
        $(mapState).find(
          targetTopic.replace("mpspath*=", "mpspath=").replace("/viewTopic/?", "/viewTopic?"),
        ).length === 1
      ) {
        targetTopic = targetTopic
          .replace("mpspath*=", "mpspath=")
          .replace("/viewTopic/?", "/viewTopic?");
        urlExactMatch = true;
      } else if (
        window.parent.location.hash !== "" &&
        window.parent.location.hash.indexOf("|") === -1
      ) {
        let hashFile = window.parent.location.hash.replace("#", "");
        let mappedHref = $(mapState)
          .find("#" + hashFile)
          .closest("[href]")
          .attr("href");

        if (mappedHref !== undefined) {
          targetTopic = '[href="' + mappedHref + '"]';
          foundHash = true;
          // console.log(targetTopic);
        } else {
          const xrefPath = action.payload?.dartSelectors?.XRefPath;
          console.log("Using XRefPath to guide selection:", xrefPath);
          $(mapState)
            .find('[mpspath*="' + window.parent.location.hash.replace("#", "") + '"]')
            .each((index, element) => {
              //  Match based on XRefPath first instead of queryString.topicfile
              // console.log("xrefPath", xrefPath);
              let currentMPSPath = $(element).attr("mpspath");
              if (xrefPath) {
                const xrefTargetId = xrefPath.split("/").pop().replace(".dita", "");
                // console.log(` [${index}] XRefPath target ID:`, xrefTargetId);
                // Check if this mpspath contains the same target ID
                if (currentMPSPath.includes(xrefTargetId)) {
                  targetTopic = '[mpspath="' + currentMPSPath + '"]:eq(0)';
                  foundHash = true;
                  return false;
                  // console.log("false-foundHash-section",targetTopic);
                }
              } else {
                if (currentMPSPath.indexOf(queryString.topicfile) > -1) {
                  targetTopic = '[mpspath="' + currentMPSPath + '"]:eq(0)';
                  foundHash = true;
                  return false;
                  // console.log("false-foundHash-else",targetTopic);
                }
              }
            });

          if (foundHash === false) {
            let findSection = $(mapState)
              .find('[mpspath*="sectionId=' + hashFile + "#" + hashFile + '"]')
              .attr("href");

            if (findSection !== undefined) {
              targetTopic = '[href="' + findSection + '"]';
              foundHash = true;
            } else {
              targetTopic = '[mpspath*="topicfile=' + queryString.topicfile + '"]:eq(0)';
            }
          }

          if (foundHash === false) {
            targetTopic = '[href*="' + hashFile + '"]';
            let findSection = $(mapState).find(targetTopic).attr("href");
            if (findSection !== undefined) {
              foundHash = true;
              targetTopic = '[href="' + findSection + '"]';
            }
          }
        }
      } else if (
        window.parent.location.search.indexOf("navigateTopic") > -1 ||
        window.parent.location.search.indexOf("?topicfile") > -1
      ) {
        targetTopic = 'topicref[mpspath*="topicfile=' + queryString.topicfile + '"]';

        // console.log(targetTopic);

        if (window.parent.location.hash !== "") {
          if (window.parent.location.hash.indexOf("|") > -1) {
            let newTargetTopic = window.location.hash.replace("#", "").split("|")[0];

            let regexPattern = /^c_\w*_/g;
            let regexTest = regexPattern.test(newTargetTopic);
            if (regexTest === true) {
              targetTopic = 'topicref[mpspath*="' + newTargetTopic + '"]';
              foundHash = true;
            }
            // console.log(regexTest,newTargetTopic);
            if (window.parent.location.search.indexOf("navigateTopic") > -1) {
              // console.log(queryString.navigateTopic);
              if (queryString.navigateTopic && queryString.navigateTopic.indexOf(".dita") > -1) {
                let navigateFromQuery = decodeURIComponent(queryString.navigateTopic);
                navigateFromQuery = navigateFromQuery.split(".dita")[0] + ".dita";
                targetTopic = '[href*="' + navigateFromQuery + '"]';
                foundHash = true;
              } else {
                const params = new URLSearchParams(window.location.search);
                const navigateTopic = params.get("navigateTopic");
                if (navigateTopic.indexOf(".dita") > -1) {
                  let navigateFromQuery = decodeURIComponent(navigateTopic);
                  navigateFromQuery = navigateFromQuery.split(".dita")[0] + ".dita";
                  targetTopic = '[href*="' + navigateFromQuery + '"]';
                  foundHash = true;
                }
              }

              $(mapState)
                .find(targetTopic)
                .each((index, element) => {
                  let targetTopicTag = $(element).prop("tagName");
                  if (targetTopicTag === "CHAPTER" || targetTopicTag === "MAPREF") {
                    targetTopic = $(element).find("topicref:eq(0)").attr("href");
                    targetTopic = '[href="' + targetTopic + '"]';
                    urlExactMatch = true;
                  }
                });
            }
          }
        } else if (window.parent.location.href.indexOf("?topicfile=c_") > -1) {
          // applies to word(docx) imported dita content
          targetTopic = 'chapter[mpspath*="' + queryString.topicfile + '"]';
          // console.log(targetTopic);
        }
      } else if (
        window.parent.location.href.indexOf("#") > -1 &&
        window.parent.location.href.indexOf("|") > -1 &&
        window.parent.location.href.indexOf(".ditamap") > -1
      ) {
        const hashPath = window.parent.location.href.split("#")[1].split("|")[0];
        targetTopic = `[href="${hashPath}.dita"]`;
        // console.log(targetTopic);
        const checkTargetTopic = $(mapState).find(targetTopic).attr("href");
        // console.log(checkTargetTopic);
        if (checkTargetTopic !== undefined) {
          foundHash = true;
        }
      }
    }

    if (uxPlatform !== "mobile") {
      if (urlExactMatch === true || foundHash === true) {
        targetTopic = $(mapState).find(targetTopic).attr("href");
        // console.log(targetTopic,"foundHash:",foundHash,"|urlexactMatch:",urlExactMatch);
      } else {
        targetTopic = $(mapState)
          .find(targetTopic)
          .not('topicref[mpspath*="guidelinename=auto"]')
          .first()
          .attr("href");
      }
    }

    if (uxPlatform !== "mobile") {
      if (targetTopic === undefined) {
        queryString = action.payload?.dartSelectors?.queryString;
        targetTopic = 'topicref[mpspath*="topicfile=' + queryString?.topicfile + '"]:eq(0)';

        targetTopic = $(mapState).find(targetTopic).attr("href");
      }
    }

    let sendDartSelectors = action.payload.request
      ? action.payload.request.dartSelectors
      : action.payload.dartSelectors;

    if (targetTopic !== undefined) {
      let targetTopicTag = $(mapState)
        .find('[href="' + [targetTopic] + '"]')
        .prop("tagName");

      if (targetTopicTag === "CHAPTER") {
        targetTopic = $(mapState)
          .find('[href="' + [targetTopic] + '"]')
          .find("topicref:eq(0)")
          .attr("href");
      }

      if (checklocalStorage) {
        localStorage.removeItem("xrefPath");
        targetTopic = checklocalStorage.split("#")[0];
        checklocalStorage = checklocalStorage.split("#")[1];
      } else {
        checklocalStorage = "";
      }
      // window.parent.location.reload();
      UpdateURL(targetTopic, sendDartSelectors, checklocalStorage);

      if (sendDartSelectors.changeGuideline === 1) {
        localStorage.setItem("xrefPath", sendDartSelectors.XRefPath);
      }
    } else if (sendDartSelectors.changeGuideline === 1) {
      localStorage.setItem("xrefPath", sendDartSelectors.XRefPath);
      if (uxPlatform !== "mobile") {
        window.parent.location.reload();
      }
    } else if (window.parent.location.href.indexOf("topicfile=c_") > -1) {
      targetTopic =
        'topicref[href="' + window.parent.location.href.split("topicfile=")[1] + '.dita"]';
      targetTopic = $(mapState).find(targetTopic).attr("href");
      if (targetTopic !== undefined) {
        //problem is with this when mutiple links it does not trigger UpdateURL
        UpdateURL(targetTopic, sendDartSelectors, checklocalStorage);
      }
    }
  }, 1000);
};

const NewTopicStyles = (stateMap, hrefSelectedTopic) => {
  // console.log("hrefSelectedTopic",hrefSelectedTopic);
  $(stateMap)
    .find("topicref.active, chapter.active, ditatitle.active, section.active, mapref.active")
    .removeClass("active");
  $(stateMap).find(hrefSelectedTopic).addClass("active");
  $(stateMap).find(hrefSelectedTopic).find("> map > topicref").addClass("active");
  $(stateMap).find(hrefSelectedTopic).parents("bookmap").find("ditatitle:eq(0)").addClass("active");
  $(stateMap).find(hrefSelectedTopic).parents("topicref, chapter").addClass("active");
  $(stateMap).find(hrefSelectedTopic).find("> topic > section").addClass("active");
};

const _getCacheContent = (state, action) => {
  try {
    let findLinkTag = "topicref, chapter";

    if ($(action.payload.contentMap).html().indexOf("<mapref") !== 0)
      if ($(action.payload.contentMap).find("mapref").length > 0) findLinkTag = "> mapref";

    state.value = [];

    $(action.payload.contentMap)
      .find(findLinkTag)
      .not(".tandf")
      .each((index, element) => {
        const topicFile = $(element).attr("href");
        let children = parseInt($(element).attr("children")) || 0;
        let level = parseInt($(element).attr("level")) || 0;
        // console.log(index,element.tagName,topicFile);
        if (
          element.parentElement.tagName === "TOPICHEAD" ||
          element.parentElement.parentElement.tagName === "MAP" ||
          element.parentElement.parentElement.tagName === "BOOKMAP"
        ) {
          // for references, indeces and to make map work.
          children = 1;
        }
        if (
          element.parentElement.tagName === "CHAPTER" ||
          element.parentElement.parentElement.tagName === "MAP"
        ) {
          // for references, indeces and to make map work.
          level = 2;
        }

        // console.log(element.parentElement.parentElement.tagName,children);
        const topicTitle = $(element).find("ditatitle:eq(0)").text();
        // console.log(topicTitle);
        let cachedContent = "";
        let loadTopic = topicFile
          .replace(".ditamap", "")
          .replace(".dita", "")
          .replace(/_/g, " ")
          .replace(/\//g, " ");
        let processingText =
          '<span class="dottext">Processing </span><div class="dot"></div><span class="dottext">' +
          loadTopic +
          "</span>";
        let logInButton = state.isAppMode
          ? "<span class='loginAlert'>Log in or subscribe to view contents.</span>"
          : '<button class="btn btn-default" onclick="document.querySelector(\'#logInbtn\').click();">Log in or subscribe to view contents.</button>';

        let subscribeButton = `<button class="btn btn-default" href="#" onClick="window.location.href = '/showMyprofile';" style="
             display: inline-block;
             white-space: normal;
             word-wrap: break-word;
             max-width: 100%;
             font-weight: 600;
          ">Your subscription has expired. Go to My Subscription in your profile to renew now.</button>`;

        const authID = { ...state.id };
        const loggedIn = userLogged(authID);
        const isWebModernisationEnabled = state.isModernView;
        const canPurchase = state.subscriptionStatus.canPurchase;
        const isCheckingSubscription = state.subscriptionStatus.status === "loading";

        // keep this for debugging in dev
        //  console.log("loggedIn expired", loggedIn, authID, expired,state.subscriptionStatus.canPurchase, state.isAppMode, state.isModernView);

        // Show loading state while checking subscription (B2C only)
        if (loggedIn && isCheckingSubscription && authID.u) {
          cachedContent = processingText;
        } else if (state.expired === true) {
          if (authID.i) {
            subscribeButton = `<button class="btn btn-default" href="#" style="
             display: inline-block;
             white-space: normal;
             word-wrap: break-word;
             max-width: 100%;
             font-weight: 600;
          ">Your subscription has expired.</button>`;
          } else if (authID.u && state.isMobileAppMode) {
            subscribeButton = `<button class="btn btn-default" href="#" style="
             display: inline-block;
             white-space: normal;
             word-wrap: break-word;
             max-width: 100%;
             font-weight: 600;
          "> Your subscription has expired. Please visit our website in a browser to subscribe.</button>`;
          } else if (isWebModernisationEnabled && canPurchase) {
            subscribeButton = `<button class="btn btn-default" href="#" onClick="window.location.href = '/subscribe';" style="
             display: inline-block;
             white-space: normal;
             word-wrap: break-word;
             max-width: 100%;
             font-weight: 600;
          ">Your subscription has expired. Please click here to subscribe again.</button>`;
          } else if (isWebModernisationEnabled && !canPurchase) {
            subscribeButton = `<button class="btn btn-default" href="#" onClick="window.location.href = '/app/accountLanding';" style="
             display: inline-block;
             white-space: normal;
             word-wrap: break-word;
             max-width: 100%;
             font-weight: 600;
          ">Your subscription has expired. Go to My Subscription in your profile to renew now.</button>`;
          }
          cachedContent = subscribeButton;
        } else if (loggedIn) {
          cachedContent = state.cache[topicFile]?.content;
        } else {
          cachedContent = logInButton;
        }

        if (
          cachedContent === undefined ||
          cachedContent === processingText ||
          cachedContent === logInButton ||
          cachedContent === subscribeButton
        ) {
          cachedContent = processingText;
          if (!loggedIn) {
            cachedContent = logInButton;
          } else if (isCheckingSubscription) {
            cachedContent = processingText;
          } else if (state.expired) {
            cachedContent = subscribeButton;
          }
          state.cache = {
            ...state.cache,
            [topicFile]: {
              title: topicTitle,
              children,
              level,
              content: cachedContent,
            },
          };

          const expired = state.expired;

          action.payload.dartSelectors.iDB.read(topicFile).then((value) => {
            if (loggedIn ||  localStorage.getItem("savedReferrer") === "https://therapeuticguidelines.sharepoint.com/") {
              if (expired) {
                action.payload.dartSelectors.dispatch(
                  iDBContent({ topicFile, value: subscribeButton }),
                );
              } else if (topicFile.indexOf(".dita") > -1 || topicFile.indexOf(".txt") > -1) {
                action.payload.dartSelectors.dispatch(
                  fetchContent({
                    guideline: action.payload.dartSelectors.ditapath,
                    topicFile,
                    dartSelectors: action.payload.dartSelectors,
                  }),
                );
              }
            } else if (value !== null) {
              action.payload.dartSelectors.dispatch(iDBContent({ topicFile, value: logInButton }));
            }
          });
        }

        if (findLinkTag !== "> mapref" && state.value.indexOf(topicFile) === -1)
          state.value.push(topicFile);
      });

    //CLEAN Cache to improve performance.
    let retainCachedTopic = [
      "chapter",
      state.referenceFiles.pbs_links,
      state.referenceFiles.drug_keydef,
      state.referenceFiles.source_experts,
    ]; // TODO: see state to update as needed.
    for (let cachedTopic in state.cache) {
      if (retainCachedTopic.indexOf(cachedTopic) > -1) {
        // console.log("Retain",cachedTopic);
      } else if (state.value.indexOf(cachedTopic) > -1) {
        // console.log("Cache",cachedTopic);
      } else {
        // console.log("Delete", cachedTopic);
        delete state.cache[cachedTopic];
      }
    }
    // console.log(state.cache);
  } catch (err) {}
};

const processCacheContent = (tag, stateMap, state, action) => {
  // console.log(contentTag,action.payload.selectedTopic);
  let contentMap = $(stateMap)
    .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
    .closest("map")
    .find("topicref:eq(0)")
    .parent();
  if (tag === "TOPICHEAD") {
    contentMap = $(stateMap)
      .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
      .closest("map")
      .find("topicref:eq(0)")
      .parent()
      .parent();
  }

  // console.log($(closestMap).html());
  if ($(contentMap).html() === undefined) {
    contentMap = $(stateMap)
      .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
      .closest("bookmap")
      .find("topicref:eq(0)")
      .parent();
    if (tag !== "CHAPTER") {
      contentMap = $(stateMap)
        .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
        .closest("bookmap")
        .find("topicref:eq(0)")
        .parent()
        .parent();
    }
  }

  //TODO: fix why content section does not update for some parents
  if (tag === "BOOKMAP" || tag === "CHAPTER") {
    contentMap = $(stateMap)
      .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
      .parent()
      .parent(); // requires parent...keep

    if ($(contentMap).find("bookmeta").length > 0) {
      // when topicref is in the root toc and there is just 1 topic.
      contentMap = $(stateMap)
        .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
        .wrap("<p>")
        .parent()
        .html();
      $(stateMap)
        .find('[href="' + action.payload.selectedTopic + '"]:eq(0)')
        .unwrap();
      contentMap = contentMap + contentMap; // dupliated because index=0 is hidden in contentsection.
      contentMap = $("<map />").html(contentMap);
      $(contentMap).find("topicref").attr("children", "1").wrap("<p>");
      // console.log($(closestMap).html());
    }
  }

  _getCacheContent(state, {
    payload: { contentMap, dartSelectors: action.payload.dartSelectors },
  });
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.

export const getAuthToken = createAsyncThunk("counter/fetchToken", async (request) => {
  const response = await fetchToken({ dartSelectors: request.dartSelectors });
  // The value we return becomes the `fulfilled` action payload
  return response.data;
});

export const fetchMap = createAsyncThunk("counter/fetchMap", async (request) => {
  const response = await fetchData({
    guideline: "",
    topicfile: request.path,
    dartSelectors: request.dartSelectors,
  });
  request.dartSelectors.iDB.write(request.path, response.data);
  // The value we return becomes the `fulfilled` action payload
  //response.data = cleanDITA(response.data);
  //console.log("===CLEANED",response.data);
  let combinedResponse = { data: response.data, request };

  return combinedResponse;
});

// This function firstly fetch dita from idb
// then call fetchContentNow which will fetch from zip
// then fetch from network if zip is not ready or any error comes up
export const fetchContentAsync = async (dartSelectors, guideline, topicFile) => {
  const iDBContent = await dartSelectors.iDB.read(topicFile);
  if (iDBContent) {
    return iDBContent;
  } else {
    return await fetchContentNow(dartSelectors, guideline, topicFile);
  }
};

export const fetchContentNow = async (dartSelectors, guideline, topicFile) => {
  let response = "";
  if (dartSelectors.zip !== null && dartSelectors.zip !== 1) {
    try {
      response = await fetchFileFromZip(guideline + topicFile, dartSelectors.zip);
      dartSelectors.iDB.write(guideline + topicFile, response.data);
    } catch (exception) {
      console.error("Failed to get file from zip - refetching");
      response = await fetchData({
        guideline: guideline,
        topicfile: topicFile,
        dartSelectors: dartSelectors,
      });
      dartSelectors.iDB.write(topicFile, response.data);
    }
  } else {
    response = await fetchData({
      guideline: guideline,
      topicfile: topicFile,
      dartSelectors: dartSelectors,
    });
    dartSelectors.iDB.write(topicFile, response.data);
  }
  return response.data;
};

export const fetchContent = createAsyncThunk("counter/fetchContent", async (request) => {
  let response = "";
  const iDBContent = await request.dartSelectors.iDB.read(request.topicFile);
  if (iDBContent) {
    return { data: iDBContent, request };
  }
  if (
    request.dartSelectors.zip !== null &&
    request.dartSelectors.zip !== 1 &&
    !(request.guideline === "quicklinks/" && request.topicFile === "patient_information_pdfs.dita")
  ) {
    // null is initial state. 1 is downloading. final state is an array
    // console.log("===>",request.guideline,request.topicFile);
    response = await fetchFileFromZip(
      request.guideline + request.topicFile,
      request.dartSelectors.zip,
    );
    // console.log(response);
    request.dartSelectors.iDB.write(request.guideline + request.topicFile, response.data);
  } else {
    response = await fetchData({
      guideline: request.guideline,
      topicfile: request.topicFile,
      dartSelectors: request.dartSelectors,
    });
    request.dartSelectors.iDB.write(request.topicFile, response.data);
  }
  // The value we return becomes the `fulfilled` action payload
  //response.data = cleanDITA(response.data);
  //console.log("===CLEANED",response.data);
  let combinedResponse = { data: response.data, request };
  return combinedResponse;
});

export const fetchSubscriptionStatusThunk = createAsyncThunk(
  "counter/fetchSubscriptionStatus",
  async (email, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const authID = state.counter.id;
      const response = await apiService.getUserProfile(email);

      const allSubs = response.data?.subscriptions ?? [];
      const tgSubscription = allSubs.find((sub) => TG_IDS.includes(String(sub.tg_subscriptionid)));
      // there will be eith 151 or 168 both records not possible in appIdentifier that will be bug if it exists for ippondart
      if (response.success && tgSubscription) {
        const { tg_expirydate, tg_couponreferrercode, tg_subscriptionid } = tgSubscription;
        const { tg_flags } = isSalesforceEnabled() ? tgSubscription : response.data.contact;
        // console.log(
        //   `isSalesforceEnabled ${isSalesforceEnabled()} tg_flags, ${tg_flags},  ${tgSubscription?.tg_flags}, ${response.data.contact.tg_flags} tg_subscriptionid ${tg_subscriptionid}`,
        // );
        const endDate = new Date(tg_expirydate);
        const today = new Date();
        endDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        let expired = endDate < today;
        // valid tg_flags are 9999,91, 1
        if (tg_subscriptionid === "168" && (tg_flags === undefined || tg_flags === 0)) {
          //tg_flags 9999 is parent license, 1 for child license  and 91 means no liceense but parent and 0  no licence at all migght be inactive so not confusing with inactive
          expired = true;
        }
        console.log("counterslice Subscription expiry check:", {
          tg_flags,
          tg_expirydate,
          expired,
          tg_subscriptionid,
        });
        const threeMonthsFromEnd = new Date(tg_expirydate);
        threeMonthsFromEnd.setMonth(threeMonthsFromEnd.getMonth() + 1);
        const hasAppliedCoupon = !!tg_couponreferrercode;
        try {
          localStorage.setItem("tg_expirydate", btoa(tg_expirydate));
        } catch (error) {
          console.error("Failed to set localStorage:", error);
        }

        return {
          canPurchase: today >= threeMonthsFromEnd,
          hasAppliedCoupon,
          expired,
        };
      }

      if (authID.i) {
        return {
          canPurchase: true,
          hasAppliedCoupon: false,
        };
      }

      return {
        canPurchase: true,
        hasAppliedCoupon: false,
        expired: true,
      };
    } catch (error) {
      // console.error("Failed to check subscription status:", error);

      const state = getState();
      const authID = state.counter.id;

      if (authID.i) {
        return rejectWithValue({
          canPurchase: true,
          hasAppliedCoupon: false,
        });
      }

      return rejectWithValue({
        canPurchase: true,
        hasAppliedCoupon: false,
        expired: true,
      });
    }
  },
);

export const fetchB2cDisabled = createAsyncThunk(
  "counter/fetchB2cDisabled",
  async ({ b2cDisabled, accountID }) => {
    return b2cDisabled;
  },
);

const _updateOpenSection = (state, action) => {
  try {
    if (action.payload.tag !== "H2" && !state.openSection.includes(action.payload.selectedTopic)) {
      state.openSection.push(action.payload.selectedTopic);
      state.C5State.databaseID = state.ditaPath.replace("/", "");
      const cleanDitapath = removeSpecialCharacters(state.ditaPath);
      // temp fix as we are send search data to ScholarlyIQ with "page_title_updated" event
      if (state.C5State.eventType !== "Searches Regular") {
        state.C5State.eventType = "Request";
      }
      state.C5State.titleID = action.payload.selectedTopic
        ?.replace(".ditamap", "")
        ?.replace(".dita", "");
      state.C5State.itemID = action.payload.selectedTopic
        ?.replace(".ditamap", "")
        ?.replace(".dita", "");
      state.C5State.itemVersion = state.mpstopicfile[cleanDitapath].mpsguidelineid; //TODO: update to version
      state.C5State.proprietaryId = "tgl:" + state.C5State.databaseID;
      state.C5State.itemPubDate = $("#contentId .reviseddate").text().trim();
      state.C5State.id = JSON.stringify(state.id);

      // console.log("ADDING> instead of toggle");
      return; // exit and avoid running the below.
    }

    let checkExistingPath =
      state.openSection.length > 0
        ? state.openSection.filter((element) => {
            return element === action.payload.selectedTopic;
          })
        : [];
    // console.log("exists?>",checkExistingPath);
    if (checkExistingPath.length === 0) {
      // add only if path does not exist.
      state.openSection.push(action.payload.selectedTopic);
    } else if (action.payload.tag) {
      let deletedOpenSection = state.openSection.filter((element) => {
        return element !== action.payload.selectedTopic;
      });
      state.openSection = deletedOpenSection;
    }
  } catch (err) {
    console.log(err);
  }
};

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    iDBContent: (state, action) => {
      // console.log(action.payload.topicFile,action.payload.value);
      try {
        state.cache[action.payload.topicFile].content = action.payload.value;
      } catch (error) {
        // console.log(error);
        let contentKey = {
          [action.payload.key]: {
            title: action.payload.key,
            children: 0,
            content: action.payload.value,
          },
        };
        state.cache = { ...state.cache, ...contentKey };
      }
    },
    iDBMap: (state, action) => {
      if (action.payload.value !== state.map) {
        state.map = action.payload.value;
      }
      OpenTOCbyURL(action, state);
    },
    updateTOC: (state, action) => {
      if (
        !import.meta.env.REACT_APP_FEATURE_ENHANCED_COUNTER ||
        import.meta.env.REACT_APP_FEATURE_ENHANCED_COUNTER === "false"
      ) {
        updateTOCJQuery(state, action);
      } else {
        updateEnhancedTOC.updateTOCOfDOM(state, action);
      }
    },
    // change Guideline
    changeGuideline: (state, action) => {
      state.changeGuideline = 1;
      let extractDitaPath = action.payload.xrefHref.replace("../../", "").split("/")[0] + "/";
      state.ditaPath = extractDitaPath;
      state.defaultPath = action.payload.xrefHref;
      state.XRefPath = action.payload.xrefHref.replace("../../" + extractDitaPath, "");
      state.value = [];
      state.openSection = [];

      // if(uxPlatform!=="mobile") {
      //   if(1){//(window.parent.location.href.indexOf("tgldcdp.tg.org.au")>-1){ // removed to fix dxp; required for mps
      //     $("body").css("opacity","0"); // to stop the flicker/jumpiness...
      //   }else{
      //   }
      // }

      // $("#contentId").html('<span class="dottext">Processing </span><div class="dot"></div><span class="dot"></span>');
      // $('body,html').animate({scrollTop:0}, 500, "swing");
    },
    setGuideline: (state, action) => {
      let search = action.payload.search;
      let searchParams = new URLSearchParams(search);
      let ditaPath = $("#tg_toc_id").attr("ditapath") || "";
      try {
        if (searchParams.get("bookTitle")) {
          ditaPath = searchParams.get("bookTitle").replaceAll(" ", "_") + "/";
          $(".etgtopic .bodyContentDiv").css("display", "none");
        } else if (searchParams.get("guidelinePage")) {
          ditaPath = searchParams.get("guidelinePage").replaceAll(" ", "_") + "/";
        } else if (searchParams.get("sectionId")) {
          const guideline_abbrv_map = {
            amg: "Addiction Medicine",
            abg: "Antibiotic",
            bmg: "Bone and Metabolism",
            cvg: "Cardiovascular",
            dmg: "Dermatology",
            ddg: "Developmental Disability",
            dbg: "Diabetes",
            ftg: "Fatigue",
            gig: "Gastrointestinal",
            ldg: "Liver Disorders",
            nrg: "Neurology",
            dtg: "Oral and Dental",
            oth: "Other",
            agg: "Pain and Analgesia",
            pcg: "Palliative Care",
            ptg: "Psychotropic",
            rsg: "Respiratory",
            rhg: "Rheumatology",
            srg: "Sexual and Reproductive Health",
            ttg: "Toxicology and Toxinology",
            lwg: "Ulcer and Wound",
            wmg: "Wilderness Medicine",
          };
          const sectionId = searchParams.get("sectionId");
          const guideline_abbrv = sectionId[2] + sectionId[3] + sectionId[4];
          ditaPath =
            guideline_abbrv_map[guideline_abbrv.toLocaleLowerCase()].replaceAll(" ", "_") + "/";
        } else {
          let topics = window.tgg.topics;
          let guidelines = window.tgg.guidelines;
          let topicFile = searchParams
            ?.get("topicfile")
            ?.replace("_1", "")
            .toLowerCase()
            .replace("-", "_");
          for (let guideline in topics) {
            for (let key in topics[guideline]) {
              if (key.toLowerCase().includes(topicFile)) {
                ditaPath = guideline;
                break;
              }
            }
          }
          if (ditaPath === "") {
            for (let guideline in guidelines) {
              for (let key in guidelines[guideline]) {
                if (key.toLowerCase().replace("-", "_").includes(topicFile)) {
                  ditaPath = guideline;
                  break;
                }
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
      if (!ditaPath?.endsWith("/")) {
        ditaPath += "/";
      }
      state.ditaPath = ditaPath;
    },
    resetDefaultPath: (state, action) => {
      state.defaultPath = "";
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateReference: (state, action) => {
      state.referenceFiles.refContent.file = action.payload.drugKey;
      state.referenceFiles.refContent.active = action.payload.active;
    },
    resetXRefPath: (state, action) => {
      state.XRefPath = "";
    },
    setShowAccessKey: (state, action) => {
      state.showAccessKey = action.payload;
    },
    updateOpenSection: (state, action) => {
      if (
        !import.meta.env.REACT_APP_FEATURE_ENHANCED_COUNTER ||
        import.meta.env.REACT_APP_FEATURE_ENHANCED_COUNTER === "false"
      ) {
        _updateOpenSection(state, action);
      } else {
        updateOpenSectionStandAlone(state, action);
      }
    },
    updateUser: (state, action) => {
      state.id.u = action.payload;
      state.C5State = { ...state.C5State, id: JSON.stringify(state.id) };
    },
    updateInstitution: (state, action) => {
      state.id.i = action.payload;
      state.institutionLoading = false; // Institution auth completed
      state.C5State = { ...state.C5State, id: JSON.stringify(state.id) };
    },
    setInstitutionLoading: (state, action) => {
      state.institutionLoading = action.payload;
    },
    updateDownloadProgress: (state, action) => {
      state.downloadProgress = action.payload;
    },
    updateDownloadIDBProgress: (state, action) => {
      const { key, percent } = action.payload;

      state.downloadIDBProgress[key] = percent;
      // on Page refresh data persistence
      sessionStorage.setItem("downloadIDBProgress", JSON.stringify(state.downloadIDBProgress));
    },
    updateDownloadZipProgress: (state, action) => {
      const { key, percent } = action.payload;

      state.downloadZipProgress[key] = percent;
      // on Page refresh data persistence
      sessionStorage.setItem("downloadZipProgress", JSON.stringify(state.downloadZipProgress));
    },
    updateState: (state, action) => {
      const { payload } = action;

      if (action.payload.C5State !== undefined) {
        console.log("C5State UPDATE:", {
          previous: state.C5State,
          changes: action.payload.C5State,
          merged: { ...state.C5State, ...action.payload.C5State },
        });

        state.C5State = { ...state.C5State, ...action.payload.C5State };
      }
      for (let key in payload) {
        if (key === "C5State") {
          continue;
        } else if (key === "openSection") {
          state["openSection"] = [...state["openSection"], payload[key]];
        } else {
          state[key] = payload[key];
        }
      }
    },
    emptyOpenSection: (state) => {
      state["openSection"] = [];
    },
    UpdateVersionByImport: (state, action) => {
      state.versionByImport = action.payload;
    },
    logoutUser: (state) => {
      state.id.u = null;
    },
    resetSubscriptionStatus: (state) => {
      state.subscriptionStatus = {
        canPurchase: true,
        hasAppliedCoupon: false,
        status: "idle",
        error: null,
        expired: true,
      }; // this is for user logout and not logged in.
    },
    setExpireSubscription: (state, action) => {
      state.expired = action.payload;
    },
    setIsAppMode: (state, action) => {
      state.isAppMode = action.payload;
    },
    setIsModernView: (state, action) => {
      state.isModernView = action.payload;
    },
    setIsMobileAppMode: (state, action) => {
      state.isMobileAppMode = action.payload;
    },
    resetState: (state, action) => {
      state.ditaPath = "";
      state.map = "";
      state.headTitle = "";
    },
    resetStateForSearch: (state, action) => {
      state.ditaPath = "";
      state.map = "";
      state.headTitle = "";
      state.value = [];
      state.openSection = [];
      state.cache = {
        chapter: {
          title: "",
          children: 0,
          content: "<div>Processing...</div>",
          level: 6,
        },
      };
    },
    resetStateForNavigation: (state, action) => {
      state.ditaPath = "";
      state.headTitle = "";
      state.value = [];
      state.openSection = [];
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getAuthToken.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAuthToken.fulfilled, (state, action) => {
        state.status = "idle";
        state.auth = action.payload;
      })
      .addCase(fetchMap.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMap.fulfilled, (state, action) => {
        state.status = "idle";

        state.map = action.payload.data;
        OpenTOCbyURL(action, state);
      })
      .addCase(fetchContent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContent.fulfilled, (state, action) => {
        state.status = "idle";
        // console.log(action);
        // console.log(state);

        if (action.payload === undefined) {
          return;
        } else {
          // console.log("=>",action);
        }
        // console.log("=>",action);

        let title = "";
        let content = "";

        if (action.payload.request.refContentFile === 1) {
          // console.log(action.payload.request.topicFile);
          state.referenceFiles.refContent.file = action.payload.request.topicFile;
          state.referenceFiles.refContent.active = 1;
          let glossaryData = $("<body />").html(action.payload.data);
          glossaryData = $(glossaryData).find("glossterm").text();
          title = glossaryData;
        } else {
          title = action.payload.request.topicFile;
        }
        content = action.payload.data;

        try {
          if (state.cache[action.payload.request.topicFile].content !== action.payload.data) {
            state.cache[action.payload.request.topicFile].content = action.payload.data;
          }
        } catch (error) {
          let topicObject = action.payload.request.topicFile;
          let contentKey = { [topicObject]: { title, children: 0, content } };
          state.cache = { ...state.cache, ...contentKey };
          // console.log(topicObject, error);
        }
        // iDB.write(action.payload.request.topicFile,action.payload.data);
        //state.value = action.payload.data;
      })
      .addCase(fetchSubscriptionStatusThunk.pending, (state) => {
        state.subscriptionStatus.status = "loading";
        state.subscriptionStatus.error = null;
      })

      .addCase(fetchSubscriptionStatusThunk.fulfilled, (state, action) => {
        state.subscriptionStatus.canPurchase = action.payload.canPurchase;
        state.subscriptionStatus.hasAppliedCoupon = action.payload.hasAppliedCoupon;
        state.subscriptionStatus.status = "succeeded";
        state.subscriptionStatus.error = null;
        if (action.payload.expired != null) {
          state.expired = action.payload.expired;
        }
      })

      .addCase(fetchSubscriptionStatusThunk.rejected, (state, action) => {
        state.subscriptionStatus.status = "failed";
        state.subscriptionStatus.error = action.error?.message;
      })
      .addCase(fetchB2cDisabled.fulfilled, (state, action) => {
        let institutionFromTgt = null;
        const tgt = localStorage.getItem("tgt");

        if (tgt) {
          try {
            const decodedToken = JSON.parse(atob(tgt));
            if (decodedToken.name) {
              institutionFromTgt = {
                name: decodedToken.name,
                id: decodedToken.id,
                orgid: decodedToken.orgid,
                shortName: decodedToken.shortName,
              };
            }
          } catch (e) {
            // Invalid token, ignore
          }
        }
        const isB2cDisabled = action.payload;
        const authIDUser = action.meta.arg?.authID?.u || null;
        const existingUser = state.id?.u || null;
        const existingInstitution = state.id?.i || null;

        if (isB2cDisabled) {
          // B2C is disabled — preserve institution if it exists, or fallback to tgt
          const finalInstitution = existingInstitution || institutionFromTgt || null;
          const finalUser = existingUser || authIDUser || null;
          state.id = {
            u: finalUser,
            i: finalInstitution,
          };
          // When B2C is disabled, subscription check is complete
          // (free access mode, no need to verify subscription)
          if (state.subscriptionStatus && state.subscriptionStatus.status === "loading") {
            state.subscriptionStatus.status = "idle";
          }
        } else {
          // B2C is enabled — clear institution unless tgt exists
          const finalInstitution = existingInstitution || institutionFromTgt || null;
          state.id = {
            u: existingUser || authIDUser || null,
            i: finalInstitution,
          };
        }
        // Optionally keep in sync with C5State if needed
        state.C5State = {
          ...state.C5State,
          id: JSON.stringify(state.id),
        };
      });
  },
});

export const {
  updateTOC,
  updateReference,
  resetXRefPath,
  updateOpenSection,
  changeGuideline,
  resetDefaultPath,
  iDBContent,
  iDBMap,
  updateState,
  updateUser,
  updateInstitution,
  setInstitutionLoading,
  updateDownloadProgress,
  updateDownloadZipProgress,
  updateDownloadIDBProgress,
  setShowAccessKey,
  emptyOpenSection,
  clearAndAddNewValue,
  UpdateVersionByImport,
  logoutUser,
  resetSubscriptionStatus,
  setGuideline,
  setExpireSubscription,
  setIsAppMode,
  setIsModernView,
  setIsMobileAppMode,
  resetState,
  resetStateForSearch,
  resetStateForNavigation,
} = counterSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectAuth = (state) => state.counter.auth;
export const selectMap = (state) => state.counter.map;
export const selectValue = (state) => state.counter.value;
export const selectCache = (state) => state.counter.cache;
export const selectVersion = (state) => state.counter.version;
export const selectMPSTopicFile = (state) => state.counter.mpstopicfile;
export const selectDitaPath = (state) => state.counter.ditaPath;
export const selectXRefPath = (state) => state.counter.XRefPath;
export const selectOpenSection = (state) => state.counter.openSection;
export const selectChangeGuideline = (state) => state.counter.changeGuideline;
export const selectC5State = (state) => state.counter?.C5State || initialState.C5State;
export const selectIP = (state) => state.counter?.ip || "";
export const selectUXPlatform = (state) => state.counter.uxPlatform;
export const selectUQueryString = (state) => state.counter.queryString;
export const selectDefaultPath = (state) => state.counter.defaultPath;
export const selectFetchQueue = (state) => state.counter.fetchqueue;
export const selectReferenceFiles = (state) => state.counter.referenceFiles;
export const selectDisplayBanner = (state) => state.counter.displayBanner;
export const selectMedium = (state) => state.counter.medium;
export const selectHeadTitle = (state) => state.counter.headTitle;
export const selectCounterStatus = (state) => state.counter.status;
export const selectTocId = (state) => state.counter.tocId;
export const selectHashRedirect = (state) => state.counter.hashRedirect;
export const selectID = (state) => state.counter.id;
export const selectInstitutionLoading = (state) => state.counter.institutionLoading;
export const selectZip = (state) => state.counter.zip;
export const selectiDB = (state) => state.counter.iDB;
export const selectVersionByImport = (state) => state.counter.versionByImport;
export const selectSubscriptionStatus = (state) => state.counter.subscriptionStatus;
export const selectExpired = (state) => state.counter.expired;
export const selectIsModernView = (state) => state.counter.isModernView;
export const selectIsMobileAppMode = (state) => state.counter.isMobileAppMode;
export const selectActiveTopicHRefSearchPath = (state) => state.counter.activeTopicHRefSearchPath;
export const selectDownloadZipProgress = (state) => state.counter.downloadZipProgress;
export const selectDownloadZip = (state) => state.counter.downloadZip;
export const selectDownloadIDBProgress = (state) => state.counter.downloadIDBProgress;
// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd = (amount) => (dispatch, getState) => {
  // const currentValue = selectCount(getState());
  // if (currentValue % 2 === 1) {
  //   dispatch(incrementByAmount(amount));
  // }
};

export default counterSlice.reducer;
